<template>
  <div>
    <component :is="blogContentComponent" v-if="blogContentComponent" />
  </div>
</template>

<script setup>
definePageMeta({
  layout: "default",
});

const route = useRoute();
const { locale } = useI18n();
const allLocaleModules = import.meta.glob("../components/blog/locals/**/*.vue");

const blogContentComponent = shallowRef(null);

usePostHreflang();

function resolveLocaleComponent() {
  const key = `../components/blog/locals/${locale.value}/${route.params.slug}.vue`;
  const loader = allLocaleModules[key];

  if (loader) {
    blogContentComponent.value = defineAsyncComponent(loader);
  } else {
    throw createError({
      statusCode: 404,
      statusMessage: "Page Not Found",
      fatal: true,
    });
  }
}

watch([locale, () => route.params.slug], resolveLocaleComponent, {
  immediate: true,
});
</script>

<style scoped></style>
